// extracted by mini-css-extract-plugin
export default {"btn":"dashboard_btn__Ov-LL","headerWrapper":"dashboard_headerWrapper__OIp+F","searchWrapper":"dashboard_searchWrapper__94o4Z","clientBtnWrapper":"dashboard_clientBtnWrapper__lAUJV"};